import type { EntityType } from '@/lib/search';

export const PERSON_KIND = 'person';
export const CROSS_TYPE_MERGE_EXCLUDED = new Set<string>(['ahoy_user']);
export const MERGE_SEARCHABLE_HOST_TYPES: readonly EntityType[] = [
  'ahoy_contact',
  'ahoy_company',
  'ahoy_deal',
];
const PERSON_SEARCH_TYPES: readonly EntityType[] = ['ahoy_contact'];

export function canMergeEntityTypes(
  aType: string,
  bType: string,
  entityKindsMap: ReadonlyMap<string, readonly string[]>
): boolean {
  if (aType === bType) {
    return true;
  }
  const aKinds = entityKindsMap.get(aType) ?? [];
  const bKinds = entityKindsMap.get(bType) ?? [];
  return (
    aKinds.includes(PERSON_KIND) &&
    bKinds.includes(PERSON_KIND) &&
    !CROSS_TYPE_MERGE_EXCLUDED.has(aType) &&
    !CROSS_TYPE_MERGE_EXCLUDED.has(bType)
  );
}

export function getMergeCandidateSearchTypes(
  entityTypeName: string,
  entityKindsMap: ReadonlyMap<string, readonly string[]>
): EntityType[] {
  if (!MERGE_SEARCHABLE_HOST_TYPES.includes(entityTypeName as EntityType)) {
    return [];
  }
  const result = new Set<EntityType>([entityTypeName as EntityType]);
  if (
    (entityKindsMap.get(entityTypeName) ?? []).includes(PERSON_KIND) &&
    !CROSS_TYPE_MERGE_EXCLUDED.has(entityTypeName)
  ) {
    for (const type of PERSON_SEARCH_TYPES) {
      if (!CROSS_TYPE_MERGE_EXCLUDED.has(type)) {
        result.add(type);
      }
    }
  }
  return Array.from(result);
}
